import React, { useState, useEffect, useRef } from 'react';

function SplitPane({ leftContent, rightContent, defaultRightPaneWidth = 350, isRightPaneOpen = true, onPaneStateChange }) {
    const [isDragging, setIsDragging] = useState(false);
    const [rightPaneWidth, setRightPaneWidth] = useState(defaultRightPaneWidth);
    const [isCollapsed, setIsCollapsed] = useState(!isRightPaneOpen);
    const containerRef = useRef(null);
    const dragStartX = useRef(0);
    const dragStartWidth = useRef(0);

    // Update collapsed state when isRightPaneOpen changes
    useEffect(() => {
        setIsCollapsed(!isRightPaneOpen);
    }, [isRightPaneOpen]);

    const handleMouseDown = (e) => {
        setIsDragging(true);
        dragStartX.current = e.clientX;
        dragStartWidth.current = rightPaneWidth;
        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    };

    const handleMouseMove = (e) => {
        if (!isDragging) return;
        const deltaX = dragStartX.current - e.clientX;
        const newWidth = Math.max(200, Math.min(600, dragStartWidth.current + deltaX));
        setRightPaneWidth(newWidth);
    };

    const handleMouseUp = () => {
        setIsDragging(false);
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
    };

    return (
        <div ref={containerRef} className="flex h-full relative">
            {/* Left Pane */}
            <div className={`flex-1 h-full overflow-hidden ${
                isCollapsed ? '' : 'mr-2'
            } ${
                !isCollapsed ? 'hidden md:block' : ''
            }`}>
                {leftContent}
            </div>

            {/* Resizer */}
            {!isCollapsed && (
                <div
                    className="w-1 bg-gray-200 hover:bg-blue-500 cursor-col-resize transition-colors hidden md:block"
                    onMouseDown={handleMouseDown}
                    role="separator"
                    aria-orientation="vertical"
                    aria-valuenow={rightPaneWidth}
                    aria-valuemin={200}
                    aria-valuemax={600}
                />
            )}

            {/* Right Pane */}
            <div
                className={`h-full transition-all duration-300 ease-in-out ${
                    isCollapsed ? 'w-0 opacity-0' : 'opacity-100'
                } ${
                    !isCollapsed ? 'w-full md:w-auto' : ''
                }`}
                style={{ width: isCollapsed ? 0 : (window.innerWidth < 768 ? '100%' : rightPaneWidth) }}
            >
                {/* Right Pane Content — the close affordance lives in the panel header */}
                <div className="h-full overflow-hidden">
                    {rightContent}
                </div>
            </div>
        </div>
    );
}

export default SplitPane; 